export const userActionTypes = {
    //Login
    LOGIN_REQUEST : 'LOGIN_REQUEST',
    LOGIN_SUCCESS : 'LOGIN_SUCCESS',
    LOGIN_FAILURE : 'LOGIN_FAILURE',

    //Register
    REGISTER_REQUEST : 'REGISTER_REQUEST',
    REGISTER_SUCCESS : 'REGISTER_SUCCESS',
    REGISTER_FAILURE : 'REGISTER_FAILURE',

    //Admin
    GET_ADMIN_REQUEST: 'GET_ADMIN_REQUEST',
    GET_ADMIN_SUCCESS: 'GET_ADMIN_SUCCESS',
    GET_ADMIN_FAILURE: 'GET_ADMIN_FAILURE',

    GET_ADMIN_ID_REQUEST: 'GET_ADMIN_ID_REQUEST',
    GET_ADMIN_ID_SUCCESS: 'GET_ADMIN_ID_SUCCESS',
    GET_ADMIN_ID_FAILURE: 'GET_ADMIN_ID_FAILURE',

    UPDATE_ADMIN_ID_REQUEST: 'UPDATE_ADMIN_ID_REQUEST',
    UPDATE_ADMIN_ID_SUCCESS: 'UPDATE_ADMIN_ID_SUCCESS',
    UPDATE_ADMIN_ID_FAILURE: 'UPDATE_ADMIN_ID_FAILURE',

    DESTROY_ADMIN_ID_REQUEST: 'DESTROY_ADMIN_ID_REQUEST',
    DESTROY_ADMIN_ID_SUCCESS: 'DESTROY_ADMIN_ID_SUCCESS',
    DESTROY_ADMIN_ID_FAILURE: 'DESTROY_ADMIN_ID_FAILURE',

    //User ID
    GET_USER_LIST_REQUEST: 'GET_USER_LIST_REQUEST',
    GET_USER_LIST_SUCCESS: 'GET_USER_LIST_SUCCESS',
    GET_USER_LIST_FAILURE: 'GET_USER_LIST_FAILURE',

    GET_USER_ID_LIST_REQUEST: 'GET_USER_ID_LIST_REQUEST',
    GET_USER_ID_LIST_SUCCESS: 'GET_USER_ID_LIST_SUCCESS',
    GET_USER_ID_LIST_FAILURE: 'GET_USER_ID_LIST_FAILURE',

    // Create User (POST)
    CREATE_USER_REQUEST: 'CREATE_USER_REQUEST',
    CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
    CREATE_USER_FAILURE: 'CREATE_USER_FAILURE',

    // Update (PUT)
    UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',

    // Delete (DELETE)
    DELETE_USER_REQUEST: 'DELETE_USER_REQUEST',
    DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
    DELETE_USER_FAILURE: 'DELETE_USER_FAILURE',

    //OTP
    CREATE_OTP_REQUEST: 'CREATE_OTP_REQUEST',
    CREATE_OTP_SUCCESS: 'CREATE_OTP_SUCCESS',
    CREATE_OTP_FAILURE: 'CREATE_OTP_FAILURE',

    //Reset Password
    CREATE_RESET_PASSWORD_REQUEST: 'CREATE_RESET_PASSWORD_REQUEST',
    CREATE_RESET_PASSWORD_SUCCESS: 'CREATE_RESET_PASSWORD_SUCCESS',
    CREATE_RESET_PASSWORD_FAILURE: 'CREATE_RESET_PASSWORD_FAILURE',

    // Templat Add (POST)
    CREATE_TEMPLAT_REQUEST: 'CREATE_TEMPLAT_REQUEST',
    CREATE_TEMPLAT_SUCCESS: 'CREATE_TEMPLAT_SUCCESS',
    CREATE_TEMPLAT_FAILURE: 'CREATE_TEMPLAT_FAILURE',

    // Templat Read (View)
    VIEW_TEMPLAT_REQUEST: 'VIEW_TEMPLAT_REQUEST',
    VIEW_TEMPLAT_SUCCESS: 'VIEW_TEMPLAT_SUCCESS',
    VIEW_TEMPLAT_FAILURE: 'VIEW_TEMPLAT_FAILURE',

    // Templat Read ID (View)
    VIEW_TEMPLAT_ID_REQUEST: 'VIEW_TEMPLAT_ID_REQUEST',
    VIEW_TEMPLAT_ID_SUCCESS: 'VIEW_TEMPLAT_ID_SUCCESS',
    VIEW_TEMPLAT_ID_FAILURE: 'VIEW_TEMPLAT_ID_FAILURE',
    
    // Templat Edit (PUT)
    UPDATE_TEMPLAT_REQUEST: 'UPDATE_TEMPLAT_REQUEST',
    UPDATE_TEMPLAT_SUCCESS: 'UPDATE_TEMPLAT_SUCCESS',
    UPDATE_TEMPLAT_FAILURE: 'UPDATE_TEMPLAT_FAILURE',

    // Templat Delete (DELETE)
    DELETE_TEMPLAT_REQUEST: 'DELETE_TEMPLAT_REQUEST',
    DELETE_TEMPLAT_SUCCESS: 'DELETE_TEMPLAT_SUCCESS',
    DELETE_TEMPLAT_FAILURE: 'DELETE_TEMPLAT_FAILURE',

    // Pendidikan Terakhir (CRUD)
    CREATE_PENDIDIKAN_ID_REQUEST: 'CREATE_PENDIDIKAN_ID_REQUEST',
    CREATE_PENDIDIKAN_ID_SUCCESS: 'CREATE_PENDIDIKAN_ID_SUCCESS',
    CREATE_PENDIDIKAN_ID_FAILURE: 'CREATE_PENDIDIKAN_ID_FAILURE',

    GET_PENDIDIKAN_ID_REQUEST: 'GET_PENDIDIKAN_ID_REQUEST',
    GET_PENDIDIKAN_ID_SUCCESS: 'GET_PENDIDIKAN_ID_SUCCESS',
    GET_PENDIDIKAN_ID_FAILURE: 'GET_PENDIDIKAN_ID_FAILURE',

    UPDATE_PENDIDIKAN_ID_REQUEST: 'UPDATE_PENDIDIKAN_ID_REQUEST',
    UPDATE_PENDIDIKAN_ID_SUCCESS: 'UPDATE_PENDIDIKAN_ID_SUCCESS',
    UPDATE_PENDIDIKAN_ID_FAILURE: 'UPDATE_PENDIDIKAN_ID_FAILURE',

    DELETE_PENDIDIKAN_ID_REQUEST: 'DELETE_PENDIDIKAN_ID_REQUEST',
    DELETE_PENDIDIKAN_ID_SUCCESS: 'DELETE_PENDIDIKAN_ID_SUCCESS',
    DELETE_PENDIDIKAN_ID_FAILURE: 'DELETE_PENDIDIKAN_ID_FAILURE',

    // Pengalaman Kerja (CRUD)
    CREATE_PENGALAMAN_REQUEST: 'CREATE_PENGALAMAN_REQUEST',
    CREATE_PENGALAMAN_SUCCESS: 'CREATE_PENGALAMAN_SUCCESS',
    CREATE_PENGALAMAN_FAILURE: 'CREATE_PENGALAMAN_FAILURE',

    GET_PENGALAMAN_ID_REQUEST: 'GET_PENGALAMAN_ID_REQUEST',
    GET_PENGALAMAN_ID_SUCCESS: 'GET_PENGALAMAN_ID_SUCCESS',
    GET_PENGALAMAN_ID_FAILURE: 'GET_PENGALAMAN_ID_FAILURE',

    UPDATE_PENGALAMAN_REQUEST: 'UPDATE_PENGALAMAN_REQUEST',
    UPDATE_PENGALAMAN_SUCCESS: 'UPDATE_PENGALAMAN_SUCCESS',
    UPDATE_PENGALAMAN_FAILURE: 'UPDATE_PENGALAMAN_FAILURE',

    DELETE_PENGALAMAN_REQUEST: 'DELETE_PENGALAMAN_REQUEST',
    DELETE_PENGALAMAN_SUCCESS: 'DELETE_PENGALAMAN_SUCCESS',
    DELETE_PENGALAMAN_FAILURE: 'DELETE_PENGALAMAN_FAILURE',

    // Prestasi Kerja (CRUD)
    CREATE_PRESTASI_ID_REQUEST: 'CREATE_PRESTASI_ID_REQUEST',
    CREATE_PRESTASI_ID_SUCCESS: 'CREATE_PRESTASI_ID_SUCCESS',
    CREATE_PRESTASI_ID_FAILURE: 'CREATE_PRESTASI_ID_FAILURE',

    GET_PRESTASI_REQUEST: 'GET_PRESTASI_REQUEST',
    GET_PRESTASI_SUCCESS: 'GET_PRESTASI_SUCCESS',
    GET_PRESTASI_FAILURE: 'GET_PRESTASI_FAILURE',

    UPDATE_PRESTASI_ID_REQUEST: 'UPDATE_PRESTASI_ID_REQUEST',
    UPDATE_PRESTASI_ID_SUCCESS: 'UPDATE_PRESTASI_ID_SUCCESS',
    UPDATE_PRESTASI_ID_FAILURE: 'UPDATE_PRESTASI_ID_FAILURE',

    DELETE_PRESTASI_ID_REQUEST: 'DELETE_PRESTASI_ID_REQUEST',
    DELETE_PRESTASI_ID_SUCCESS: 'DELETE_PRESTASI_ID_SUCCESS',
    DELETE_PRESTASI_ID_FAILURE: 'DELETE_PRESTASI_ID_FAILURE',

    // Keahlian (CRUD)
    CREATE_KEAHLIAN_ID_REQUEST: 'CREATE_KEAHLIAN_ID_REQUEST',
    CREATE_KEAHLIAN_ID_SUCCESS: 'CREATE_KEAHLIAN_ID_SUCCESS',
    CREATE_KEAHLIAN_ID_FAILURE: 'CREATE_KEAHLIAN_ID_FAILURE',

    GET_KEAHLIAN_ID_REQUEST: 'GET_KEAHLIAN_ID_REQUEST',
    GET_KEAHLIAN_ID_SUCCESS: 'GET_KEAHLIAN_ID_SUCCESS',
    GET_KEAHLIAN_ID_FAILURE: 'GET_KEAHLIAN_ID_FAILURE',

    UPDATE_KEAHLIAN_ID_REQUEST: 'UPDATE_KEAHLIAN_ID_REQUEST',
    UPDATE_KEAHLIAN_ID_SUCCESS: 'UPDATE_KEAHLIAN_ID_SUCCESS',
    UPDATE_KEAHLIAN_ID_FAILURE: 'UPDATE_KEAHLIAN_ID_FAILURE',

    DELETE_KEAHLIAN_ID_REQUEST: 'DELETE_KEAHLIAN_ID_REQUEST',
    DELETE_KEAHLIAN_ID_SUCCESS: 'DELETE_KEAHLIAN_ID_SUCCESS',
    DELETE_KEAHLIAN_ID_FAILURE: 'DELETE_KEAHLIAN_ID_FAILURE',

    // Pelatihan (CRUD)
    CREATE_PELATIHAN_ID_REQUEST: 'CREATE_PELATIHAN_ID_REQUEST',
    CREATE_PELATIHAN_ID_SUCCESS: 'CREATE_PELATIHAN_ID_SUCCESS',
    CREATE_PELATIHAN_ID_FAILURE: 'CREATE_PELATIHAN_ID_FAILURE',

    GET_PELATIHAN_ID_REQUEST: 'GET_PELATIHAN_ID_REQUEST',
    GET_PELATIHAN_ID_SUCCESS: 'GET_PELATIHAN_ID_SUCCESS',
    GET_PELATIHAN_ID_FAILURE: 'GET_PELATIHAN_ID_FAILURE',

    UPDATE_PELATIHAN_ID_REQUEST: 'UPDATE_PELATIHAN_ID_REQUEST',
    UPDATE_PELATIHAN_ID_SUCCESS: 'UPDATE_PELATIHAN_ID_SUCCESS',
    UPDATE_PELATIHAN_ID_FAILURE: 'UPDATE_PELATIHAN_ID_FAILURE',

    DELETE_PELATIHAN_ID_REQUEST: 'DELETE_PELATIHAN_ID_REQUEST',
    DELETE_PELATIHAN_ID_SUCCESS: 'DELETE_PELATIHAN_ID_SUCCESS',
    DELETE_PELATIHAN_ID_FAILURE: 'DELETE_PELATIHAN_ID_FAILURE',

    // Portofolio (CRUD)
    CREATE_PORTOFOLIO_REQUEST: 'CREATE_PORTOFOLIO_REQUEST',
    CREATE_PORTOFOLIO_SUCCESS: 'CREATE_PORTOFOLIO_SUCCESS',
    CREATE_PORTOFOLIO_FAILURE: 'CREATE_PORTOFOLIO_FAILURE',

    GET_PORTOFOLIO_ID_REQUEST: 'GET_PORTOFOLIO_ID_REQUEST',
    GET_PORTOFOLIO_ID_SUCCESS: 'GET_PORTOFOLIO_ID_SUCCESS',
    GET_PORTOFOLIO_ID_FAILURE: 'GET_PORTOFOLIO_ID_FAILURE',

    UPDATE_PORTOFOLIO_ID_REQUEST: 'UPDATE_PORTOFOLIO_ID_REQUEST',
    UPDATE_PORTOFOLIO_ID_SUCCESS: 'UPDATE_PORTOFOLIO_ID_SUCCESS',
    UPDATE_PORTOFOLIO_ID_FAILURE: 'UPDATE_PORTOFOLIO_ID_FAILURE',

    DELETE_PORTOFOLIO_ID_REQUEST: 'DELETE_PORTOFOLIO_ID_REQUEST',
    DELETE_PORTOFOLIO_ID_SUCCESS: 'DELETE_PORTOFOLIO_ID_SUCCESS',
    DELETE_PORTOFOLIO_ID_FAILURE: 'DELETE_PORTOFOLIO_ID_FAILURE',

    // Combined Data
    SET_USER_DETAILS: 'SET_USER_DETAILS',
    SET_PENGALAMAN_KERJA: 'SET_PENGALAMAN_KERJA',
    SET_PRESTASI_KERJA: 'SET_PRESTASI_KERJA',
    SET_PENDIDIKAN_TERAKHIR: 'SET_PENDIDIKAN_TERAKHIR',
    SET_KEAHLIAN: 'SET_KEAHLIAN',
    SET_PELATIHAN: 'SET_PELATIHAN',
    COMBINED_DATA: 'COMBINED_DATA',
};
